import { HtmlBlockEditModal } from 'articleEditor/modals/htmlBlockEditModal';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { MyHtmlElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';
import { useModal } from 'lib-knowledge-modal';
import { useCallback } from 'react';

import HtmlBlockPlaceholder from './htmlBlockPlaceholder';
import HtmlBlockValue from './htmlBlockValue';

export type HtmlBlockProps = RenderElementProps & {
  element: MyHtmlElement;
};

export default function HtmlBlock({
  element,
  attributes,
  children,
}: HtmlBlockProps): JSX.Element {
  const editor = useMyEditorRef();
  const { showModal } = useModal();
  const editHtmlBlock = useCallback(() => {
    showModal(HtmlBlockEditModal, {
      element,
      editor,
    });
  }, [editor, element, showModal]);

  return (
    <div>
      {element.html ? (
        <HtmlBlockValue
          element={element}
          attributes={attributes}
          onEditHtmlBlock={editHtmlBlock}
        >
          {children}
        </HtmlBlockValue>
      ) : (
        <HtmlBlockPlaceholder
          element={element}
          attributes={attributes}
          onEditHtmlBlock={editHtmlBlock}
        >
          {children}
        </HtmlBlockPlaceholder>
      )}
    </div>
  );
}
